/* ==========================================================================
   Mix (bundle com selecao item a item) - Juliana Prado / tema Royce
   Arquivo: assets/mix-bundle.js
   ========================================================================== */

(function () {
  'use strict';

  var MONEY_FORMAT = '{{amount}}';

  function formatMoney(cents, format) {
    var value = typeof cents === 'number' ? cents : parseInt(cents, 10) || 0;
    var fmt = format || MONEY_FORMAT;

    function withDelimiters(number, precision, thousands, decimal) {
      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.');
      var intPart = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var decPart = parts[1] ? decimal + parts[1] : '';
      return intPart + decPart;
    }

    var placeholder = fmt.match(/\{\{\s*(\w+)\s*\}\}/);
    var name = placeholder ? placeholder[1] : 'amount';
    var formatted;

    switch (name) {
      case 'amount_no_decimals':
        formatted = withDelimiters(value, 0, ',', '.');
        break;
      case 'amount_with_comma_separator':
        formatted = withDelimiters(value, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        formatted = withDelimiters(value, 0, '.', ',');
        break;
      case 'amount_with_apostrophe_separator':
        formatted = withDelimiters(value, 2, "'", '.');
        break;
      default:
        formatted = withDelimiters(value, 2, ',', '.');
    }

    return fmt.replace(/\{\{\s*\w+\s*\}\}/, formatted);
  }

  function pad(n) {
    return n < 10 ? '0' + n : String(n);
  }

  function MixBundle(root) {
    this.root = root;
    this.moneyFormat = root.getAttribute('data-money-format') || MONEY_FORMAT;
    this.items = Array.prototype.slice.call(root.querySelectorAll('[data-mix-item]'));
    this.totalEl = root.querySelector('[data-mix-total]');
    this.totalCompareEl = root.querySelector('[data-mix-total-compare]');
    this.addBtn = root.querySelector('[data-mix-add]');
    this.addBtnText = root.querySelector('[data-mix-add-text]');
    this.messageEl = root.querySelector('[data-mix-message]');
    this.messageTimer = null;
    this.defaultBtnLabel = this.addBtnText ? this.addBtnText.textContent : 'Adicionar ao carrinho';

    this.init();
  }

  MixBundle.prototype.init = function () {
    var self = this;

    if (this.root.getAttribute('data-hide-default') === 'true') {
      document.body.classList.add('mix-bundle-active');
    }

    this.items.forEach(function (item) {
      self.setupItem(item);
    });

    if (this.addBtn) {
      this.addBtn.addEventListener('click', function () {
        self.addToCart();
      });
    }

    this.updateTotal();
  };

  MixBundle.prototype.setupItem = function (item) {
    var self = this;
    var check = item.querySelector('[data-mix-check]');
    var minus = item.querySelector('[data-mix-qty-minus]');
    var plus = item.querySelector('[data-mix-qty-plus]');
    var input = item.querySelector('[data-mix-qty-input]');
    var variantsScript = item.querySelector('[data-mix-variants]');

    item._qty = 1;
    item._variants = [];
    item._options = [];

    if (variantsScript) {
      try {
        item._variants = JSON.parse(variantsScript.textContent);
      } catch (e) {
        item._variants = [];
      }
      var current = item._variants.filter(function (v) {
        return String(v.id) === item.getAttribute('data-variant-id');
      })[0];
      item._options = current ? current.o.slice() : [];
    }

    if (check) {
      check.addEventListener('change', function () {
        self.updateTotal();
        self.clearMessage();
      });
    }

    if (minus) {
      minus.addEventListener('click', function () {
        self.changeQty(item, -1);
      });
    }

    if (plus) {
      plus.addEventListener('click', function () {
        self.changeQty(item, 1);
      });
    }

    if (input) {
      input.value = pad(item._qty);
    }

    item.querySelectorAll('[data-mix-acc-toggle]').forEach(function (toggle) {
      toggle.addEventListener('click', function () {
        var acc = toggle.closest('[data-mix-acc]');
        var wasOpen = acc.classList.contains('is-open');
        item.querySelectorAll('[data-mix-acc]').forEach(function (other) {
          other.classList.remove('is-open');
        });
        if (!wasOpen) acc.classList.add('is-open');
      });
    });

    item.querySelectorAll('[data-mix-chip]').forEach(function (chip) {
      chip.addEventListener('click', function () {
        if (chip.classList.contains('is-unavailable')) return;
        var idx = parseInt(chip.getAttribute('data-option-index'), 10);
        item._options[idx] = chip.getAttribute('data-value');
        self.selectVariant(item);
        var acc = chip.closest('[data-mix-acc]');
        if (acc) acc.classList.remove('is-open');
      });
    });

    this.refreshChipAvailability(item);
  };

  MixBundle.prototype.selectVariant = function (item) {
    var opts = item._options;
    var match = item._variants.filter(function (v) {
      for (var i = 0; i < opts.length; i++) {
        if (opts[i] != null && v.o[i] !== opts[i]) return false;
      }
      return true;
    })[0];

    if (!match) return;

    item.setAttribute('data-variant-id', match.id);
    item.setAttribute('data-price', match.p);
    item.setAttribute('data-compare-at-price', match.c > match.p ? match.c : 0);
    item.setAttribute('data-available', match.a ? 'true' : 'false');
    item.setAttribute('data-inventory-max', match.q);

    var priceEl = item.querySelector('[data-mix-price]');
    if (priceEl) priceEl.textContent = formatMoney(match.p, this.moneyFormat);

    var compareEl = item.querySelector('[data-mix-compare]');
    if (compareEl) {
      if (match.c > match.p) {
        compareEl.textContent = formatMoney(match.c, this.moneyFormat);
        compareEl.hidden = false;
      } else {
        compareEl.hidden = true;
      }
    }

    var img = item.querySelector('[data-mix-image] img');
    if (img && match.img) img.src = match.img;

    item.querySelectorAll('[data-mix-acc]').forEach(function (acc) {
      var idx = parseInt(acc.getAttribute('data-option-index'), 10);
      var valueEl = acc.querySelector('[data-mix-acc-value]');
      if (valueEl) valueEl.textContent = match.o[idx] || '';
      acc.querySelectorAll('[data-mix-chip]').forEach(function (chip) {
        chip.classList.toggle('is-selected', chip.getAttribute('data-value') === match.o[idx]);
      });
    });

    var check = item.querySelector('[data-mix-check]');
    if (check) {
      check.disabled = !match.a;
      if (!match.a) check.checked = false;
    }
    item.classList.toggle('mix-item--unavailable', !match.a);

    var max = parseInt(item.getAttribute('data-inventory-max'), 10) || 9999;
    if (item._qty > max) item._qty = Math.max(1, max);
    this.renderQty(item);
    this.refreshChipAvailability(item);
    this.updateTotal();
  };

  MixBundle.prototype.refreshChipAvailability = function (item) {
    if (!item._variants.length) return;
    var opts = item._options;

    item.querySelectorAll('[data-mix-acc]').forEach(function (acc) {
      var idx = parseInt(acc.getAttribute('data-option-index'), 10);
      acc.querySelectorAll('[data-mix-chip]').forEach(function (chip) {
        var candidate = opts.slice();
        candidate[idx] = chip.getAttribute('data-value');
        var exists = item._variants.some(function (v) {
          for (var i = 0; i < candidate.length; i++) {
            if (i === idx) {
              if (v.o[i] !== candidate[i]) return false;
            } else if (candidate[i] != null && v.o[i] !== candidate[i]) {
              return false;
            }
          }
          return v.a;
        });
        chip.classList.toggle('is-unavailable', !exists);
      });
    });
  };

  MixBundle.prototype.changeQty = function (item, delta) {
    var max = parseInt(item.getAttribute('data-inventory-max'), 10) || 9999;
    var next = item._qty + delta;

    if (next < 1) return;

    if (next > max) {
      this.showTip(item, 'Só temos ' + max + ' unidade' + (max > 1 ? 's' : '') + ' em estoque.');
      return;
    }

    item._qty = next;
    this.renderQty(item);
    this.updateTotal();
  };

  MixBundle.prototype.renderQty = function (item) {
    var input = item.querySelector('[data-mix-qty-input]');
    var minus = item.querySelector('[data-mix-qty-minus]');
    var plus = item.querySelector('[data-mix-qty-plus]');
    var max = parseInt(item.getAttribute('data-inventory-max'), 10) || 9999;

    if (input) input.value = pad(item._qty);
    if (minus) minus.disabled = item._qty <= 1;
    if (plus) plus.disabled = item._qty >= max;
  };

  MixBundle.prototype.showTip = function (item, text) {
    var tip = item.querySelector('[data-mix-tip]');
    if (!tip) return;
    tip.textContent = text;
    tip.classList.add('is-visible');
    clearTimeout(item._tipTimer);
    item._tipTimer = setTimeout(function () {
      tip.classList.remove('is-visible');
    }, 2600);
  };

  MixBundle.prototype.getSelected = function () {
    return this.items.filter(function (item) {
      var check = item.querySelector('[data-mix-check]');
      return check && check.checked && !check.disabled && item.getAttribute('data-available') === 'true';
    });
  };

  MixBundle.prototype.updateTotal = function () {
    var selected = this.getSelected();
    var total = 0;
    var compareTotal = 0;

    selected.forEach(function (item) {
      var price = parseInt(item.getAttribute('data-price'), 10) || 0;
      var compare = parseInt(item.getAttribute('data-compare-at-price'), 10) || 0;
      total += price * item._qty;
      compareTotal += (compare > price ? compare : price) * item._qty;
    });

    if (this.totalEl) this.totalEl.textContent = formatMoney(total, this.moneyFormat);
    var mixWrap = document.body.classList.contains('mix-bundle-active') ? document.querySelector('.product-price-wrapper.product-main-price') : null;
    var mixPriceEl = mixWrap ? mixWrap.querySelector('.product-actual-price') : null;
    if (mixPriceEl) mixPriceEl.textContent = formatMoney(total, this.moneyFormat);
    var mixInst = mixWrap ? mixWrap.querySelector('.product__installments') : null;
    if (mixInst && !mixInst.getAttribute('data-mix-tpl')) mixInst.setAttribute('data-mix-tpl', mixInst.textContent.trim());
    var mixTpl = mixInst ? mixInst.getAttribute('data-mix-tpl') : '';
    var mixParts = mixTpl ? mixTpl.match(/(\d+)\s*x/) : null;
    var mixN = mixParts ? parseInt(mixParts[1], 10) : 0;
    if (mixInst) mixInst.style.display = (total > 0 && mixN) ? '' : 'none';
    if (mixInst && total > 0 && mixN) mixInst.textContent = mixTpl.replace(/R\$\s*[\d.,]+/, formatMoney(Math.round(total / mixN), this.moneyFormat));
    

    if (this.totalCompareEl) {
      if (compareTotal > total) {
        this.totalCompareEl.textContent = formatMoney(compareTotal, this.moneyFormat);
        this.totalCompareEl.hidden = false;
      } else {
        this.totalCompareEl.hidden = true;
      }
    }

    if (this.addBtn) this.addBtn.disabled = selected.length === 0;
  };

  MixBundle.prototype.showMessage = function (text, type) {
    if (!this.messageEl) return;
    clearTimeout(this.messageTimer);
    this.messageEl.textContent = text;
    this.messageEl.classList.remove('mix-bundle__message--success', 'mix-bundle__message--error');
    this.messageEl.classList.add(type === 'success' ? 'mix-bundle__message--success' : 'mix-bundle__message--error');
    this.messageEl.hidden = false;
    var self = this;
    this.messageTimer = setTimeout(function () {
      self.messageEl.hidden = true;
    }, 5000);
  };

  MixBundle.prototype.clearMessage = function () {
    if (!this.messageEl) return;
    clearTimeout(this.messageTimer);
    this.messageEl.hidden = true;
  };

  MixBundle.prototype.addToCart = function () {
    var self = this;
    var selected = this.getSelected();

    if (!selected.length) {
      this.showMessage('Selecione pelo menos uma peça do mix.', 'error');
      return;
    }

    var payload = {
      items: selected.map(function (item) {
        return {
          id: parseInt(item.getAttribute('data-variant-id'), 10),
          quantity: item._qty
        };
      })
    };

    var cart = document.querySelector('cart-drawer');
    if (cart && typeof cart.getSectionsToRender === 'function') {
      payload.sections = cart.getSectionsToRender().map(function (section) {
        return section.id;
      });
      payload.sections_url = window.location.pathname;
    }

    var addUrl = (window.routes && window.routes.cart_add_url) || '/cart/add';
    if (addUrl.indexOf('.js') === -1) addUrl += '.js';

    this.addBtn.classList.add('is-loading');
    this.addBtn.disabled = true;
    if (this.addBtnText) this.addBtnText.textContent = 'Adicionando...';

    fetch(addUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
      body: JSON.stringify(payload)
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (data) {
        if (data.status) {
          self.showMessage(data.description || data.message || 'Não foi possível adicionar o mix.', 'error');
          return;
        }

        if (cart && typeof cart.renderContents === 'function' && data.sections) {
          cart.renderContents(data);
          cart.classList.remove('is-empty');
          cart.classList.add('is-visible');
          document.body.classList.add('overflow-hidden');
          self.showMessage('Mix adicionado ao carrinho.', 'success');
        } else {
          window.location.href = (window.routes && window.routes.cart_url) || '/cart';
        }
      })
      .catch(function (error) {
        console.error('[mix-bundle]', error);
        self.showMessage('Não foi possível adicionar o mix. Tente novamente.', 'error');
      })
      .finally(function () {
        self.addBtn.classList.remove('is-loading');
        self.addBtn.disabled = false;
        if (self.addBtnText) self.addBtnText.textContent = self.defaultBtnLabel;
        self.updateTotal();
      });
  };

  function boot() {
    document.querySelectorAll('[data-mix-bundle]').forEach(function (root) {
      if (root._mixBundle) return;
      root._mixBundle = new MixBundle(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
